import { render, staticRenderFns } from "./headerIntegration.vue?vue&type=template&id=28ed661c&scoped=true&"
import script from "./headerIntegration.vue?vue&type=script&lang=js&"
export * from "./headerIntegration.vue?vue&type=script&lang=js&"
import style0 from "./headerIntegration.vue?vue&type=style&index=0&id=28ed661c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ed661c",
  null
  
)

export default component.exports